import React, { useState } from "react";
import { PlanCard } from "@/pages/particular-signup/select_plan/plans";
import EmbeddedCheckoutComponent from "@/pages/particular-signup/select_plan/EmbeddedCheckout";
import { useNavigate } from "react-router-dom";

const OWNER_PLANS = [
  {
    id: "featured",
    name: "PRO ilimitado",
    duration: "1 mes",
    type: "Inmobiliaria",
    price: "2300",
    badge: "Mejor valor",
    isHighlighted: true,
    highlightText: "Pública propiedades sin límite",
    proListings: true,
    annualFee: null,
    features: [
      { text: "15 propiedades destacadas", included: true },
      {
        text: "8 usuarios administradores",
        included: true,
      },
      {
        text: "Alta visibilidad en los resultados de búsqueda",
        included: true,
      },
      {
        text: "Edita tu publicación sin límites",
        included: true,
      },
      {
        text: "Acceso a analítica (Obtén reporte de tus publicaciones)",
        included: true,
      },
      {
        text: "Sube imágenes ilimitadas y videos",
        included: true,
      },
    ],
    idPlan: "pro-ilimitado",
    priceId:
      import.meta.env.VITE_PUBLIC_ILIMITADO || "price_1RMLJFHGBw2VKdDPBgd7gBKG",
  },
  {
    id: "pro-50",
    name: "PRO 50",
    duration: "1 mes",
    type: "Inmobiliaria",
    price: "1500",
    originalPrice: null,
    badge: null,
    isHighlighted: false,
    highlightText: "Pública 50 propiedades",
    proListings: true,
    annualFee: null,
    features: [
      { text: "8 propiedades destacadas", included: true },
      {
        text: "5 usuarios administradores",
        included: true,
      },
      {
        text: "Alta visibilidad en los resultados de búsqueda",
        included: true,
      },
      {
        text: "Edita tu publicación sin límites",
        included: true,
      },
      {
        text: "Acceso a analítica \n (Obtén reporte de tus publicaciones)",
        included: true,
      },
      {
        text: "Sube imágenes ilimitadas y videos",
        included: true,
      },
    ],
    idPlan: "pro-50",
    priceId:
      import.meta.env.VITE_PUBLIC_PRO_50 || "price_1RRyajHGBw2VKdDPkbHkgY9m",
  },
  {
    id: "pro-mini",
    name: "PRO mini",
    duration: "1 mes",
    type: "Inmobiliaria",
    price: "500",
    originalPrice: null,
    badge: null,
    isHighlighted: false,
    highlightText: "Pública 5 propiedades",
    annualFee: null,
    features: [
      { text: "1 propiedad destacada", included: true },
      { text: "1 usuario administrador", included: true },
      {
        text: "Alta visibilidad en los resultados de búsqueda",
        included: true,
      },
      { text: "Edita tu publicación sin límites", included: true },
      {
        text: "Acceso a analítica\n(Obtén reportes de tu publicación)",
        included: true,
      },
      {
        text: "Sube imágenes ilimitadas y videos de tu propiedad",
        included: true,
      },
    ],
    idPlan: "pro-mini",
    priceId:
      import.meta.env.VITE_PUBLIC_MINI || "price_1RRyVxHGBw2VKdDPBfxdZ9eh",
  },
  {
    id: "pro-gratis",
    name: "PRO Gratis",
    duration: null,
    type: null,
    price: null,
    originalPrice: null,
    badge: null,
    isHighlighted: false,
    highlightText:
      "Conoce nuestra plataforma de CRM y paga al publicar un anuncio",
    features: [
      { text: "1 usuario administrador", included: true },
      { text: "Edita tu publicación sin límites", included: true },
      {
        text: "Sube imágenes ilimitadas y videos de tu propiedad",
        included: true,
      },
    ],
    idPlan: "pro-gratis",
    priceId: null,
  },
];

export default function SelectPlan({ selectedPlanId }) {
  const navigate = useNavigate();
  const [showCheckout, setShowCheckout] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(selectedPlanId);
  const getSelectedPriceId = () => {
    const plan = OWNER_PLANS.find((p) => p.idPlan === selectedPlan);
    return plan ? plan.priceId : null;
  };

  const handleBackToPlans = () => {
    setShowCheckout(false);
  };

  return (
    <>
      {showCheckout ? (
        <div className="w-full flex items-center justify-center">
          <EmbeddedCheckoutComponent
            priceId={getSelectedPriceId()}
            onBack={handleBackToPlans}
          />
        </div>
      ) : (
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-16 lg:px-4 xl:px-16 py-10">
          <h2 className="text-2xl font-semibold mb-6 text-center">
            Elige un plan para comenzar
          </h2>
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            {OWNER_PLANS.map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                planType="owner"
                selectedPlan={selectedPlan}
                onSelectPlan={(e) => {
                  setSelectedPlan(e);
                  if (e === "pro-gratis") {
                    navigate("/inicio");
                  } else {
                    setShowCheckout(true);
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
